import React from "react";
import { usePlansContext } from "../../../context/PlansContext";
import {
    findPlanByHandle,
    getPlanPrice,
    estimateCostByEmailCount,
} from "../../../utils/calculators";
import { steps } from "../../../utils/steps";
import { useAppContext } from "../../../context/AppContext";
import { OUTBOUND, INBOUND, TRANSACTIONAL_API, FEATURE_PROTECT_DOMAINS } from "../../../utils/constants";

import { updateCart } from "../../../api/cartAPI";
import { navigate } from "@reach/router";
import SummaryFooter from "./summaryFooter";

const SummaryFooterContainer = props => {
    const {
        state: { plans },
    } = usePlansContext();

    const {
        state: { loading },
    } = useAppContext();

    const {
        state: {
            inbound: { planHandle: inboundHandle, allocation: inboundAllocation },
            outbound: { planHandle: outboundHandle, allocation: outboundAllocation },
            transactional: { planHandle: txHandle },
        },
        dispatch,
    } = useAppContext();

    if (!plans) return null;

    let inboundPlan;
    let inboundFeatureHandle;
    let inboundPrice = 0;
    let outboundPlan;
    let emailCount = outboundAllocation ? outboundAllocation : 0;
    let outboundEstimate = 0;
    let outboundPrice = 0;
    let txPlan;
    let txPrice = 0;

    if (inboundHandle) {
        inboundPlan = findPlanByHandle(inboundHandle, plans[INBOUND]);
        inboundPrice = getPlanPrice(inboundPlan, inboundAllocation, outboundHandle);

        let inboundFeature = inboundPlan.features.find(feature =>
            FEATURE_PROTECT_DOMAINS.includes(feature.handle)
        );
        if (inboundFeature) {
            inboundFeatureHandle = inboundFeature.handle;
        }
    }
    if (outboundHandle) {
        outboundPlan = findPlanByHandle(outboundHandle, plans[OUTBOUND]);
        outboundPrice = outboundPlan.basePrice;
        outboundEstimate = outboundHandle ? estimateCostByEmailCount(emailCount, outboundPlan) : 0;
    }
    if (txHandle) {
        txPlan = findPlanByHandle(txHandle, plans[TRANSACTIONAL_API]);
        txPrice = txPlan.basePrice;
    }

    const subTotal = inboundPrice + outboundEstimate + txPrice;
    const dueToday = inboundPrice + outboundPrice + txPrice;
    const handleClick = () => {
        let params = {};

        if (inboundHandle !== null && inboundFeatureHandle !== null) {
            params["inbound_plan"] = {
                handle: inboundHandle,
                features: {
                    [inboundFeatureHandle]: inboundAllocation,
                },
            };
        }

        /**
         * if inbound domains <= 5 and outbound is selected, don's sign up for inbound
         * since they already included as free with outbound
         */
        if (outboundHandle !== null && inboundAllocation <= 5) {
            params["inbound_plan"] = null;
        }

        if (outboundHandle !== null) {
            params["outbound_plan"] = {
                handle: outboundHandle,
            };
        }

        if (txHandle !== null) {
            params["transactional_plan"] = {
                handle: txHandle,
            };
        }

        updateCart(params, dispatch)
            .then(response => {
                navigate(steps[1].url);
            })
            .catch(error => {
                console.log(error);
            });
    };

    return (
        <SummaryFooter
            inbound={
                inboundPlan
                    ? {
                          planName: inboundPlan.planName,
                          domains: inboundAllocation,
                          basePrice: inboundPrice,
                      }
                    : null
            }
            outbound={
                outboundPlan
                    ? {
                          planName: outboundPlan.planName,
                          includedEmails: outboundPlan.includedEmails,
                          extraEmails: emailCount - outboundPlan.includedEmails,
                          basePrice: outboundPlan.basePrice,
                          estimate: outboundEstimate,
                      }
                    : null
            }
            transactional={
                txPlan
                    ? {
                          planName: txPlan.planName,
                          basePrice: txPlan.basePrice,
                      }
                    : null
            }
            subTotal={subTotal}
            dueToday={dueToday}
            buttonText={"Create Account"}
            loading={loading}
            onButtonClick={handleClick}
        />
    );
};

export default SummaryFooterContainer;
